import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { ISport } from 'app/shared/model/sport.model';
import { getEntities as getSports } from 'app/entities/sport/sport.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './book.reducer';
import { IBook } from 'app/shared/model/book.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface IBookUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface IBookUpdateState {
  isNew: boolean;
  sportId: number;
  createdById: number;
  lastModifiedById: number;
}

export class BookUpdate extends React.Component<IBookUpdateProps, IBookUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      sportId: 0,
      createdById: 0,
      lastModifiedById: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getSports();
    this.props.getUsers(0, 2500, 'email');
  }

  saveEntity = (event, errors, values) => {
    values.createdDate = new Date(values.createdDate);
    values.lastModifiedDate = new Date(values.lastModifiedDate);

    if (errors.length === 0) {
      const { bookEntity } = this.props;
      const entity = {
        ...bookEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/book');
  };

  sportUpdate = element => {
    const name = element.target.value.toString();
    if (name === '') {
      this.setState({
        sportId: -1
      });
    } else {
      for (const i in this.props.sports) {
        if (name === this.props.sports[i].name.toString()) {
          this.setState({
            sportId: this.props.sports[i].id
          });
        }
      }
    }
  };

  createdByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        createdById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            createdById: this.props.users[i].id
          });
        }
      }
    }
  };

  lastModifiedByUpdate = element => {
    const login = element.target.value.toString();
    if (login === '') {
      this.setState({
        lastModifiedById: -1
      });
    } else {
      for (const i in this.props.users) {
        if (login === this.props.users[i].login.toString()) {
          this.setState({
            lastModifiedById: this.props.users[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { bookEntity, sports, users, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="webBasedManualApp.book.home.createOrEditLabel">Create or edit a Book</h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : bookEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">ID</Label>
                    <AvInput id="book-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="nameLabel" for="name">
                    Name
                  </Label>
                  <AvField
                    id="book-name"
                    type="text"
                    name="name"
                    validate={{
                      required: { value: true, errorMessage: 'This field is required.' },
                      maxLength: { value: 200, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="iconNameLabel" for="iconName">
                    Icon Name
                  </Label>
                  <AvField
                    id="book-iconName"
                    type="text"
                    name="iconName"
                    validate={{
                      required: { value: true, errorMessage: 'This field is required.' },
                      maxLength: { value: 250, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="bannerNameLabel" for="bannerName">
                    Banner Name
                  </Label>
                  <AvField
                    id="book-bannerName"
                    type="text"
                    name="bannerName"
                    validate={{
                      required: { value: true, errorMessage: 'This field is required.' },
                      maxLength: { value: 250, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="bookUrlLabel" for="bookUrl">
                    Book Url
                  </Label>
                  <AvField
                    id="book-bookUrl"
                    type="text"
                    name="bookUrl"
                    validate={{
                      required: { value: true, errorMessage: 'This field is required.' },
                      maxLength: { value: 250, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="descriptionLabel" for="description">
                    Sales Page URL
                  </Label>
                  <AvField
                    id="book-description"
                    type="text"
                    name="description"
                    validate={{
                      maxLength: { value: 1000, errorMessage: 'This field cannot be longer than {{ max }} characters.' }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="createdDateLabel" for="createdDate">
                    Created Date
                  </Label>
                  <AvInput
                    id="book-createdDate"
                    type="datetime-local"
                    className="form-control"
                    name="createdDate"
                    value={isNew ? null : convertDateTimeFromServer(this.props.bookEntity.createdDate)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="lastModifiedDateLabel" for="lastModifiedDate">
                    Last Modified Date
                  </Label>
                  <AvInput
                    id="book-lastModifiedDate"
                    type="datetime-local"
                    className="form-control"
                    name="lastModifiedDate"
                    value={isNew ? null : convertDateTimeFromServer(this.props.bookEntity.lastModifiedDate)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="isFreeLabel" check>
                    <AvInput id="book-isFree" type="checkbox" className="form-control" name="isFree" />
                    Is Free
                  </Label>
                </AvGroup>
                <AvGroup>
                  <Label for="sport.name">Sport</Label>
                  <AvInput id="book-sport" type="select" className="form-control" name="sport.name" onChange={this.sportUpdate}>
                    {sports
                      ? sports.map(otherEntity => (
                          <option value={otherEntity.name} key={otherEntity.id}>
                            {otherEntity.name}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-sport" type="hidden" name="sport.id" value={this.state.sportId} />
                </AvGroup>
                <AvGroup>
                  <Label for="createdBy.login">Created By</Label>
                  <AvInput
                    id="book-createdBy"
                    type="select"
                    className="form-control"
                    name="createdBy.login"
                    onChange={this.createdByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.filter(userEntity => userEntity.login === 'stevedav' || userEntity.login === 'michael').map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-createdBy" type="hidden" name="createdBy.id" value={this.state.createdById} />
                </AvGroup>
                <AvGroup>
                  <Label for="lastModifiedBy.login">Last Modified By</Label>
                  <AvInput
                    id="book-lastModifiedBy"
                    type="select"
                    className="form-control"
                    name="lastModifiedBy.login"
                    onChange={this.lastModifiedByUpdate}
                  >
                    <option value="" key="0" />
                    {users
                      ? users.filter(userEntity => userEntity.login === 'stevedav' || userEntity.login === 'michael').map(otherEntity => (
                          <option value={otherEntity.login} key={otherEntity.id}>
                            {otherEntity.login}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="book-lastModifiedBy" type="hidden" name="lastModifiedBy.id" value={this.state.lastModifiedById} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/book" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">Back</span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp; Save
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  sports: storeState.sport.entities,
  users: storeState.userManagement.users,
  bookEntity: storeState.book.entity,
  loading: storeState.book.loading,
  updating: storeState.book.updating
});

const mapDispatchToProps = {
  getSports,
  getUsers,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(BookUpdate);
